export const OtaPath = {
  CONFIRMATION: '/reservation/confirmation'
}

export const SSO_MODE = {
  TRIPLA_PORTAL: 'tripla_portal',
  DIRECT: 'direct_idp_redirect'
}
